/**
 * Signin
 */

import {Fab} from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import InputAdornment from '@material-ui/core/InputAdornment';
import LinearProgress from '@material-ui/core/LinearProgress';
import Toolbar from '@material-ui/core/Toolbar';
import EmailIcon from '@material-ui/icons/Email';
import LockIcon from '@material-ui/icons/Lock';
import QueueAnim from 'rc-queue-anim';
import React, {Component} from 'react';
import {NotificationManager} from 'react-notifications';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {compose} from 'redux';
import {Field} from 'redux-form';
import {signinUserInBackend} from '../../actions';
import CustomTextField from '../../components/Input/CustomTextField';
import AppConfig from '../../config/AppConfig';
import {
    resourceCustomUsers,
    endpointGetExternalServiceAuthUrl,
    externalServiceProviderFacebook,
    externalServiceProviderGoogle,
    siteUrlTerms,
    siteUrlPrivacy,
} from '../../constants';
import {SimpleForm} from '../../controlComponents';
import {withDataProvider} from '../../fetchApi/dataProvider';
import {FETCH} from '../../fetchApi/types';
import IntlMessage from '../../util/IntlMessage.tsx';
import LoginFormToolbar from './LoginFormToolbar';
import SessionSlider from './SessionSlider';
import ReCAPTCHA from "react-google-recaptcha";

const sanitizeRestProps = (props) => {
    const {signinUserInBackend, ...sanitizedProps} = props;
    return sanitizedProps;
};

const getAuthorizeUrlForExternalService = async (provider, dataProvider) => {
    dataProvider(FETCH, `${resourceCustomUsers}/${endpointGetExternalServiceAuthUrl}`, {provider})
        .then((data) => {
            window.location.assign(data.data.url);
        })
        .catch((e) => {
            NotificationManager.error(e.message);
        });
};

const formValidate = (fields) => {
    const errors = {};
    const fieldsToValidate = ['password', 'email'];
    fieldsToValidate.forEach((fieldName) => {
        if (!fields[fieldName]) {
            errors[fieldName] = 'Field is required';
        }
    });
    if (!!fields.email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,6}$/i.test(fields.email)) {
        errors.email = 'Email is invalid';
    }
    return errors;
};

class Signin extends Component {
    recaptchaRef = React.createRef();

    /**
     * On User Login
     */
    onUserLogin = async (values) => {
        const captchaToken = await this.recaptchaRef.current.executeAsync();
        this.recaptchaRef.current.reset();
        values['captchaToken'] = captchaToken;

        this.props.signinUserInBackend(values, this.props.history);
    };

    /**
     * On User Sign Up
     */
    onUserSignUp = () => {
        this.props.history.push('/signup');
    };

    render() {
        const {loading, dataProvider, ...restProps} = this.props;
        return (
            <QueueAnim type="bottom" duration={2000}>
                <div className="rct-session-wrapper">
                    {loading && <LinearProgress />}
                    <AppBar position="static" className="session-header">
                        <Toolbar>
                            <div className="container">
                                <div className="d-flex justify-content-between">
                                    <div className="session-logo">
                                        {/*    <Link to="/">*/}
                                        {/*        <img src={AppConfig.appLogo} alt="session-logo" className="img-fluid"*/}
                                        {/*             width="110" height="35"/>*/}
                                        {/*    </Link>*/}
                                    </div>
                                    <div>
                                        <a className="mr-15" onClick={() => this.onUserSignUp()}>
                                            Create new account?
                                        </a>
                                        <Button
                                            variant="contained"
                                            className="btn-light"
                                            onClick={() => this.onUserSignUp()}
                                        >
                                            Sign Up
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </Toolbar>
                    </AppBar>
                    <div className="session-inner-wrapper">
                        <div className="container">
                            <div className="row row-eq-height">
                                <div className="col-sm-7 col-md-7 col-lg-8">
                                    <div className="session-body text-center">
                                        <div className="session-head mb-30">
                                            <h2 className="font-weight-bold">Sign it to {AppConfig.brandName}</h2>
                                            <p className="mb-0">Most powerful document management platform</p>
                                        </div>
                                        <SimpleForm
                                            {...sanitizeRestProps(restProps)}
                                            form="sign-up-form"
                                            save={this.onUserLogin}
                                            toolbar={<LoginFormToolbar buttonLabel="actions.sign_in" />}
                                            validate={formValidate}
                                        >
                                            <Grid
                                                container
                                                justify="space-between"
                                                spacing={0}
                                                alignContent="flex-start"
                                                className="edit-form-grid"
                                            >
                                                <Grid item md={12} xs={12}>
                                                    <Field
                                                        type="email"
                                                        name="email"
                                                        id="user-mail"
                                                        autoFocus
                                                        label={<IntlMessage id="login.fields.email" />}
                                                        component={CustomTextField}
                                                        InputProps={{
                                                            endAdornment: (
                                                                <InputAdornment position="end">
                                                                    <EmailIcon />
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                        variant="outlined"
                                                    />
                                                </Grid>
                                                <Grid item md={12} xs={12}>
                                                    <Field
                                                        type="password"
                                                        name="password"
                                                        label={<IntlMessage id="login.fields.password" />}
                                                        component={CustomTextField}
                                                        variant="outlined"
                                                        InputProps={{
                                                            endAdornment: (
                                                                <InputAdornment position="end">
                                                                    <LockIcon />
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>
                                            <ReCAPTCHA
                                                ref={this.recaptchaRef}
                                                sitekey={'6Lc5m9IgAAAAALJ4zRgTNnapzm7MO67hHl_9HTZs'}
                                                size='invisible'
                                            />
                                        </SimpleForm>
                                        <p className='sign-in-links'>
                                            <Link to="/signup">
                                                Create new account
                                            </Link>
                                            <Link to="/signInTroubleshooting">
                                                Have troubles with sign in?
                                            </Link>
                                        </p>
                                        <p className="mb-20">or sign in with</p>
                                        <Fab
                                            variant="round"
                                            size="small"
                                            className="btn-facebook ml-10 mr-10 mb-20 text-white"
                                            onClick={() => {
                                                getAuthorizeUrlForExternalService(
                                                    externalServiceProviderFacebook, dataProvider);
                                            }}
                                        >
                                            <i className="zmdi zmdi-facebook" />
                                        </Fab>
                                        <Fab
                                            variant="round"
                                            size="small"
                                            className="btn-google ml-10 mr-10 mb-20 text-white"
                                            onClick={() => {
                                                getAuthorizeUrlForExternalService(
                                                    externalServiceProviderGoogle, dataProvider);
                                            }}
                                        >
                                            <i className="zmdi zmdi-google" />
                                        </Fab>
                                        <p className="text-muted">By signing in you agree to {AppConfig.brandName}</p>
                                        <p className="mb-0 text-muted">
                                            <a target="_blank" href={siteUrlTerms} className="text-muted" rel="noreferrer">
                                                Terms of Service
                                            </a> and <a target="_blank" href={siteUrlPrivacy} className="text-muted" rel="noreferrer">
                                                Privacy policy
                                            </a>
                                        </p>
                                    </div>
                                </div>
                                <div className="col-sm-5 col-md-5 col-lg-4">
                                    <SessionSlider />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </QueueAnim>
        );
    }
}

// map state to props
const mapStateToProps = ({authUser}) => {
    const {user, loading} = authUser;
    return {user, loading};
};

const EnhancedSignIn = compose(
    connect(mapStateToProps, {signinUserInBackend}),
    withDataProvider,
)(Signin);

export default EnhancedSignIn;
